import { Box, Button, Paper, Stack, Typography, Divider } from '@mui/material';
import { Link } from 'react-router';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import CardMembershipIcon from '@mui/icons-material/CardMembership';
import EmailIcon from '@mui/icons-material/Email';
import useT from '@hooks/useT';

function RootIndex() {
  const { t } = useT();
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        p: { xs: 2, sm: 4 },
        background: (theme) =>
          `linear-gradient(135deg, ${theme.palette.primary.dark} 0%, ${theme.palette.primary.main} 50%, ${theme.palette.secondary.main} 100%)`,
        minHeight: '100vh',
      }}>
      <Paper
        elevation={3}
        sx={{
          maxWidth: { xs: '100%', sm: 600, md: 700 },
          width: '100%',
          borderRadius: 3,
          overflow: 'hidden',
          boxShadow: '0px 10px 25px rgba(0, 0, 0, 0.3)',
        }}>
        {/* Header */}
        <Box
          sx={{
            background: (theme) =>
              `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
            py: 4,
            px: 3,
            textAlign: 'center',
          }}>
          <Stack spacing={2} alignItems="center">
            <CardMembershipIcon sx={{ fontSize: 56, color: 'white' }} />
            <Typography variant="h4" component="h1" sx={{ color: 'white', fontWeight: 600 }}>
              {t('app.title')}
            </Typography>
            <Typography variant="body1" sx={{ color: 'rgba(255, 255, 255, 0.9)' }}>
              {t('app.subtitle')}
            </Typography>
          </Stack>
        </Box>

        {/* Content */}
        <Box sx={{ p: { xs: 3, sm: 4 }, backgroundColor: 'background.paper' }}>
          <Stack spacing={3}>
            {/* Admin Section */}
            <Stack spacing={2}>
              <Stack direction="row" spacing={1} alignItems="center">
                <AdminPanelSettingsIcon color="primary" />
                <Typography variant="h6">{t('homepage.administration')}</Typography>
              </Stack>
              <Typography variant="body2" color="text.secondary">
                {t('homepage.administrationDesc')}
              </Typography>
              <Box>
                <Button
                  variant="contained"
                  component={Link}
                  to="/admin"
                  startIcon={<AdminPanelSettingsIcon />}>
                  {t('actions.goToAdmin')}
                </Button>
              </Box>
            </Stack>

            <Divider />

            {/* Member Card Section */}
            <Stack spacing={2}>
              <Stack direction="row" spacing={1} alignItems="center">
                <EmailIcon color="primary" />
                <Typography variant="h6">{t('homepage.cardSignature')}</Typography>
              </Stack>
              <Typography variant="body2" color="text.secondary">
                {t('homepage.cardSignatureDesc')}
              </Typography>
              <Paper
                variant="outlined"
                sx={{ p: 2, backgroundColor: 'grey.50', borderRadius: 2 }}>
                <Typography variant="body2" color="text.secondary">
                  {t('homepage.checkEmail')}
                </Typography>
              </Paper>
            </Stack>
          </Stack>
        </Box>
      </Paper>
    </Box>
  );
}

export default RootIndex;
